import omit from 'lodash.omit';
import {
  ADD_AUCTIONS,
  UPDATE_AUCTIONS,
  REMOVE_AUCTIONS,
  CLEAR_AUCTIONS,
  UPDATE_SELECTED_AUCTION_LANE,
  UPDATE_SELECTED_AUCTION_LANE_SUB_FILTER,
  SET_SYNC_AUCTIONS_DATA_REQUEST,
  ADD_AUCTION_ID_TO_WAITING_FOR_SYNC_COLLECTION,
  ADD_AUCTION_IDS_TO_WAITING_FOR_SYNC_COLLECTION,
  CLEAR_AUCTION_IDS_WAITING_FOR_SYNC_COLLECTION,
  UPDATE_AD_HOC_SEARCH_IS_ACTIVE,
  UPDATE_LAST_SYNC_AUCTIONS_DATA_REQUEST_TIMESTAMP,
  UPDATE_HAS_MORE_PAGES,
  UPDATE_AUCTION_LANES_REFRESHING,
  UPDATE_SAVED_SEARCH_IS_ACTIVE,
  UPDATE_VIEWING_AUCTION_MODEL,
  UPDATE_LEGACY_AUCTION_RANK_IN_LIST,
  RETAIN_GRAPHQL_SUBSCRIPTION,
  REMOVE_GRAPHQL_SUBSCRIPTION_BY_AUCTION_IDS,
} from './marketplace-auctions.mutations.type';

const mutations = {
  [ADD_AUCTIONS](state, auctions) {
    const combinedAuctions = [
      ...state.auctions,
      ...auctions,
    ];
    state.auctions = combinedAuctions;
  },
  [UPDATE_AUCTIONS](state, auctions) {
    const localAuctions = [...state.auctions];
    auctions.forEach((auction) => {
      const existingAuctionIndex = localAuctions
        .findIndex((newAuction) => newAuction.id === auction.id);
      if (existingAuctionIndex > -1) {
        if (localAuctions[existingAuctionIndex].status === 'active'
          && localAuctions[existingAuctionIndex].status === auction.status
        ) {
          // If the new high bid received is lesser than the current high bid we have
          // do not update that active auction which is in the same auction status
          if (auction.highBid < localAuctions[existingAuctionIndex].highBid
          ) {
            return;
          }
        }

        // Intentionally changed watchlist value should be retained
        // in the event the received auction watchlist value differs
        // Due to polling updates latency on watchlist boolean changes SBT-983
        const watchListToSet = localAuctions[existingAuctionIndex].isOnWatchList
            !== auction.isOnWatchList
          ? localAuctions[existingAuctionIndex].isOnWatchList
          : auction.isOnWatchList;

        localAuctions[existingAuctionIndex] = {
          ...localAuctions[existingAuctionIndex],
          ...auction,
          isOnWatchList: watchListToSet,
        };
      } else {
        localAuctions.push(auction);
      }
    });
    state.auctions = localAuctions;
  },
  [REMOVE_AUCTIONS](state, auctions) {
    const localAuctions = [...state.auctions];
    const auctionIdsToRemove = auctions.map((auction) => auction.id);
    const filteredAuctions = localAuctions
      .filter((auction) => !auctionIdsToRemove.includes(auction.id));
    state.auctions = filteredAuctions;
  },
  [CLEAR_AUCTIONS](state) {
    state.auctions = [];
  },
  [UPDATE_SELECTED_AUCTION_LANE](state, selectedAuctionLane) {
    state.selectedAuctionLane = selectedAuctionLane;
  },
  [UPDATE_SELECTED_AUCTION_LANE_SUB_FILTER](state, selectedAuctionLaneSubFilter) {
    state.selectedAuctionLaneSubFilter = selectedAuctionLaneSubFilter;
  },
  [UPDATE_VIEWING_AUCTION_MODEL](state, viewingAuction) {
    state.viewingAuctionModel = viewingAuction;
  },
  [UPDATE_LEGACY_AUCTION_RANK_IN_LIST](state, rankInList) {
    state.legacyAuctionRankInList = rankInList;
  },
  [SET_SYNC_AUCTIONS_DATA_REQUEST](state, syncAuctionsDataRequest) {
    state.syncAuctionsDataRequest = syncAuctionsDataRequest;
  },
  [ADD_AUCTION_ID_TO_WAITING_FOR_SYNC_COLLECTION](state, auctionId) {
    state.auctionIdsWaitingToSync = [...new Set([
      ...state.auctionIdsWaitingToSync,
      auctionId,
    ])];
  },
  [ADD_AUCTION_IDS_TO_WAITING_FOR_SYNC_COLLECTION](state, auctionIds) {
    state.auctionIdsWaitingToSync = [...new Set([
      ...state.auctionIdsWaitingToSync,
      ...auctionIds,
    ])];
  },
  [CLEAR_AUCTION_IDS_WAITING_FOR_SYNC_COLLECTION](state) {
    state.auctionIdsWaitingToSync = [];
  },
  [UPDATE_AD_HOC_SEARCH_IS_ACTIVE](state, adHocSearchIsActive) {
    state.adHocSearchIsActive = adHocSearchIsActive;
  },
  [UPDATE_SAVED_SEARCH_IS_ACTIVE](state, savedSearchIsActive) {
    state.savedSearchIsActive = savedSearchIsActive;
  },
  [UPDATE_LAST_SYNC_AUCTIONS_DATA_REQUEST_TIMESTAMP](state, lastSyncAuctionsDataRequestTimestamp) {
    state.lastSyncAuctionsDataRequestTimestamp = lastSyncAuctionsDataRequestTimestamp;
  },
  [UPDATE_HAS_MORE_PAGES](state, hasMorePages) {
    state.hasMorePages = hasMorePages;
  },
  [UPDATE_AUCTION_LANES_REFRESHING](state, refreshing) {
    state.auctionLanesRefreshing = refreshing;
  },
  [RETAIN_GRAPHQL_SUBSCRIPTION](state, subscription) {
    const auctionId = subscription.variables.auction_ids[0];
    state.auctionSubscriptions[auctionId] = subscription;
  },
  [REMOVE_GRAPHQL_SUBSCRIPTION_BY_AUCTION_IDS](state, auctionIds) {
    state.auctionSubscriptions = omit(state.auctionSubscriptions, auctionIds);
  },
};

export default mutations;
